import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RestoreIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              d='M384 256.5h48v135l112.5 67.5-24 39-136.5-82.5v-159zM415.5 96c159 0 288 129 288 288s-129 288-288 288c-79.5 0-150-31.5-202.5-84l45-46.5c40.5 40.5 96 66 157.5 66 124.5 0 225-99 225-223.5s-100.5-223.5-225-223.5-223.5 99-223.5 223.5h96l-129 129-3-4.5-124.5-124.5h96c0-159 129-288 288-288z'/> ]
  getViewBox = () => '0 0 768 768'
}
